import { GameModel } from "@nolimitcity/slot-game/bin/model/GameModel";
import { Presentation } from "./Presentation";
import { PresentationController } from "./PresentationController";

export class PresentationManager {

    private dataModel: GameModel<any, any>;

    private presentations: PresentationController[] = [];

    constructor(model: GameModel<any, any>) {
        this.dataModel = model;
    }

    public addController(presentations: Presentation[], modeState:string): PresentationController {

        const presentationController = new PresentationController(presentations, this.dataModel, modeState);

        this.presentations.push(presentationController);

        return presentationController;
    }

    public initPresentations(): void { this.presentations.forEach(p => p.InitPresentations()); }
}